import { ProductAgreementDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';

export enum AgreementActionTypes {
    LoadAgreementsByProduct = '[Agreements] LoadAgreementsByProduct',
    LoadAgreementsByProductSuccess = '[Agreements] LoadAgreementsByProductSuccess',
    LoadAgreementsByProductFailure = '[Agreements] LoadAgreementsByProductFailure',

    AgreementsActionFailure = '[Agreements] AgreementsActionFailure',

    UpsertProductAgreement = '[Agreements] UpsertProductAgreement',
    DeleteAgreement = '[Agreements] DeleteProductAgreement'
}
export const LoadAgreementsByProduct = createAction(AgreementActionTypes.LoadAgreementsByProduct, props<{ productId: string }>());
export const LoadAgreementsByProductSuccess = createAction(
    AgreementActionTypes.LoadAgreementsByProductSuccess,
    props<{ agreements: ProductAgreementDTO[]; productId: string }>()
);
export const LoadAgreementsByProductFailure = createAction(AgreementActionTypes.LoadAgreementsByProductFailure, props<{ error: any }>());

export const AgreementsActionFailure = createAction(AgreementActionTypes.AgreementsActionFailure, props<{ error: any }>());

export const UpsertProductAgreement = createAction(
    AgreementActionTypes.UpsertProductAgreement,
    props<{ agreement: ProductAgreementDTO }>()
);
export const DeleteAgreement = createAction(AgreementActionTypes.DeleteAgreement, props<{ productAgreementId: string }>());
